import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home'
import Menu from './components/Menu'
import ChiSiamo from './components/ChiSiamo';
import Contatti from './components/Contatti';
import Footer from './components/Footer';

function App() {

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/menu" element={<Menu/>} />
          <Route path="/about" element={<ChiSiamo/>} />
          <Route path="/contatti" element={<Contatti/>} />
        </Routes>
      </Router>
      <Footer/>
    </div>
  );
}

export default App;
